export const entitiesSelector = ({ admin }) => admin.lockReturn.entities;
export const isFetchingEntitiesSelector = ({ admin }) => admin.lockReturn.isFetchingEntities;
export const isUpdatingEntitiesSelector = ({ admin }) => admin.lockReturn.isUpdatingEntities;
